"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".application-version[_ngcontent-%COMP%]{display:none;width:200px;text-align:center;padding:10px 0;color:#dedede;font-family:monospace;font-size:10px}"];
exports.styles = styles;
